export default "__VITE_ASSET__CRwvrcrC__"